module.exports = __webpack_public_path__ + "static/media/itemsImage.7993554b.svg";